export default __webpack_public_path__ + "static/media/Techseminal.e6a9fda0.png";